import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DeleteConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  office = null, 
  isMultiple = false, 
  selectedCount = 0 
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="fixed inset-0 z-300 bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="w-full max-w-md bg-card border border-border rounded-lg shadow-elevation-3 animate-slide-up">
          {/* Header */}
          <div className="p-6 border-b border-border">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-error/10 rounded-full flex items-center justify-center">
                <Icon name="AlertTriangle" size={20} className="text-error" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground font-arabic">
                  {isMultiple ? 'حذف المناصب المحددة' : 'حذف المنصب'}
                </h3>
                <p className="text-sm text-muted-foreground">
                  هذا الإجراء لا يمكن التراجع عنه
                </p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="p-6">
            {isMultiple ? (
              <div className="space-y-4">
                <p className="text-sm text-foreground">
                  هل أنت متأكد من حذف <span className="font-semibold text-error">{selectedCount}</span> منصب؟
                </p>
                <div className="p-3 bg-error/5 border border-error/20 rounded-lg">
                  <div className="flex items-start space-x-2">
                    <Icon name="Info" size={16} className="text-error mt-0.5 flex-shrink-0" />
                    <div className="text-xs text-error">
                      <p className="font-medium mb-1">تحذير:</p>
                      <ul className="space-y-1">
                        <li>• سيتم حذف جميع البيانات المرتبطة بهذه المناصب</li>
                        <li>• لن يتمكن الأعضاء من الوصول إلى معلومات هذه المناصب</li>
                        <li>• سيتم إعادة ترتيب المناصب المتبقية تلقائياً</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="space-y-4">
                <p className="text-sm text-foreground">
                  هل أنت متأكد من حذف منصب{' '}
                  <span className="font-semibold text-error">
                    {office?.name}
                  </span>؟
                </p>
                
                {office && (
                  <div className="p-3 bg-muted/50 rounded-lg">
                    <div className="text-sm space-y-1">
                      <p><span className="font-medium">المنصب:</span> {office?.title}</p>
                      <p><span className="font-medium">القسم:</span> {office?.department}</p>
                      <p><span className="font-medium">البريد الإلكتروني:</span> {office?.email}</p>
                    </div>
                  </div>
                )}

                <div className="p-3 bg-error/5 border border-error/20 rounded-lg">
                  <div className="flex items-start space-x-2">
                    <Icon name="AlertTriangle" size={16} className="text-error mt-0.5 flex-shrink-0" />
                    <div className="text-xs text-error">
                      <p className="font-medium mb-1">سيتم حذف:</p>
                      <ul className="space-y-1">
                        <li>• جميع معلومات المنصب</li>
                        <li>• صورة الملف الشخصي</li>
                        <li>• معلومات الاتصال</li>
                        <li>• المسؤوليات والأوصاف</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end space-x-3 p-6 border-t border-border">
            <Button
              variant="ghost"
              onClick={onClose}
            >
              إلغاء
            </Button>
            
            <Button
              variant="destructive"
              onClick={handleConfirm}
              iconName="Trash2"
              iconPosition="left"
              iconSize={16}
            >
              {isMultiple ? `حذف ${selectedCount} منصب` : 'حذف المنصب'}
            </Button>
          </div>
        </div>
      </div>
      {/* Click outside to close */}
      <div 
        className="absolute inset-0 -z-10"
        onClick={onClose}
      />
    </div>
  );
};

export default DeleteConfirmationModal;